import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_offer_participate_in_any_apprenticeship_trainee_in'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_offer_participate_in_any_apprenticeship_trainee_in',
  name: 'Does the facility offer/ participate in any apprenticeship / trainee / internship programs?',
  description:
    'Apprenticeship refers to a period of time in which individuals (apprentices) receive in depth on the job training for a trade or craft from person(s) that are highly skilled in that particular trade or craft. Government-driven apprenticeship programs, if applicable, are included in scope. \r\r\n\r\r\nThe most significant differences between apprenticeships and trainee programs tend to be the time period involved. Apprenticeships tend to be longer (i.e. years) and Trainee programs shorter (i.e. months). \r\r\n\r\r\nTrainee program refers to a period of time in which knowledge and/or skills needed for proficiency within a job or activity is sought. Programs may be for new, unskilled workers or for existing workers to upgrade their skills.\r\r\n\r\r\nProbationary periods / trial periods are covered separately, and should not be recorded here.\r\r\n\r\r\nInternship program is work experience offered by the facility for a limited period of time. Typically arranged for those interested in joining a certain profession (meaning field of work) or those that have already joined a profession, but are at the beginning stages. In some cases, internships are school-linked programs, whereby interns might earn school credit.\r\r\n\r\r\nApplicable legislation may have specific definitions for these types of work arrangements. If legal definitions exist, follow those definitions to determine your answer.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-app-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4740,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
